module.exports = __webpack_public_path__ + "static/fonts/open-sans-extrabold.842476c.woff2";